import { useContext } from "react";
import { StaticResourcesContext } from "../../context/StaticResources/StaticResourcesContext";

const useQueues = () => {
	const { fetchQueues, queuesCache, loadingStates } = useContext(StaticResourcesContext);

	// ✅ OPTIMIZADO: Usar cache inteligente en lugar de llamada directa
	const findAll = async (forceUpdate = false) => {
        console.log("🚀 useQueues.findAll() - usando cache inteligente");
        return await fetchQueues(forceUpdate);
    };

	return { 
		findAll, 
		queuesCache, // Para acceso directo al cache si se necesita
		loading: loadingStates.queues // Estado de carga
	};
};

export default useQueues;
